import { useTranslation } from 'react-i18next';
import { Input, IconNames } from '@triumph/design-system';
import {
  SearchResultCount,
  SearchSection,
} from '../NOACenter.StyledComponents';

interface CarrierSearchProps {
  value: string;
  onChange: (term: string) => void;
  resultCount: number;
  showCount: boolean;
}

export const CarrierSearch: React.FC<CarrierSearchProps> = ({
  value,
  onChange,
  resultCount,
  showCount,
}) => {
  const { t } = useTranslation('noaCenter');

  return (
    <SearchSection data-testid="noa-search-section">
      <Input
        id="noa-carrier-search"
        value={value}
        placeholder={t('search.placeholder')}
        leftIcon={{ iconName: IconNames.Bold_Search, show: true }}
        onChange={(e) => onChange(e.target.value)}
        data-testid="noa-search-input"
      />
      {showCount && (
        <SearchResultCount data-testid="noa-search-count">
          {t('search.carriersFound', { count: resultCount })}
        </SearchResultCount>
      )}
    </SearchSection>
  );
};
